// extracted by mini-css-extract-plugin
module.exports = {"root":"H_bJ","icon":"H_cj","main-search-icon":"H_cK","mainSearchIcon":"H_cK","label-icon-default-filled":"H_cL","labelIconDefaultFilled":"H_cL"};